import request from "../utils/request"

export function fetchMachineLearningAlgorithms() {
  return request({ url: "/admin/machine-learning/algorithms", method: "get" })
}

export function predictSnakeWeightTrend(petId, predictionHorizonDays) {
  return request({
    url: "/admin/machine-learning/algorithms/snake-weight-trend/predictions",
    method: "get",
    params: { petId, predictionHorizonDays }
  })
}

export function fetchSnakeWeightTrainingRuns() {
  return request({
    url: "/admin/machine-learning/algorithms/snake-weight-trend/training-runs",
    method: "get"
  })
}

export function trainSnakeWeightModel(trainingFile, testingFile) {
  const data = new FormData()
  data.append("trainingFile", trainingFile)
  data.append("testingFile", testingFile)
  return request({
    url: "/admin/machine-learning/algorithms/snake-weight-trend/training-runs",
    method: "post",
    data,
    timeout: 120000
  })
}

export function publishSnakeWeightModel(runId) {
  return request({
    url: `/admin/machine-learning/algorithms/snake-weight-trend/training-runs/${runId}/publish`,
    method: "post",
    timeout: 45000
  })
}
